module.exports = __webpack_public_path__ + "static/img/4areaB_9.7e931b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/4areaB_9.png
// module id = 1189
// module chunks = 1